import { Text, View } from '@react-pdf/renderer';

import { Tkv2PDFPage } from '../../components/Tkv2PDFPage.tsx';
import { fontStyles, certificationPageStyles as styles } from '../../styles.ts';
import { CertificationStatementPageProps } from '../../types.ts';

export const CertificationStatementPage = ({
  subjectAddress,
  hasArvOption,
  inspectionData,
}: CertificationStatementPageProps) => {
  const hasInspection = inspectionData?.hasInspection;

  const items: string[] = [
    'The statements of fact contained in this report are true and correct, and I have not knowingly withheld any significant information.',
    'The analyses, opinions, and conclusions in this report are my personal, impartial, and unbiased professional work product.',
    'I have no present or prospective interest in the property that is the subject of this report and no personal interest or bias with respect to the parties involved.',
    'I did not base any part of my analysis or value conclusion on the race, color, religion, sex, age, marital status, disability, familial status, or national origin of any prospective owner or occupant, or on any other factor prohibited by the Fair Housing Act or the Equal Credit Opportunity Act.',
    'My compensation is not contingent upon reporting a predetermined value, a direction in value, or an outcome favorable to any party.',
    'I developed and reported this appraisal in conformity with the Uniform Standards of Professional Appraisal Practice.',
    'No one provided significant real property appraisal assistance to the person signing this certification, unless identified herein.',
    'I hold the appropriate state credential for this assignment. Prior to accepting this assignment, I determined that I have the knowledge and experience necessary to complete it competently, or I have taken the steps necessary to achieve competency in accordance with the Competency Rule of USPAP.',
    'Using information available in the normal course of business, I researched and analyzed any current agreement of sale, prior sale, or listing of the subject property within three years of the effective date, and prior sales of comparable properties within one year of their sale dates.',
    hasInspection
      ? 'I did not inspect the subject property. I developed my analyses and opinion of value through the Appraisify Hybrid Platform, relying on a property data report from Inspectify, Inc. in lieu of a personal inspection.'
      : 'I did not inspect the subject property. I developed my analyses and opinion of value through the Appraisify Desktop Platform, relying on digital data sources in lieu of a personal or third-party inspection.',
    'I did not inspect the exterior of the comparable sales used in this report. Information on the comparables was obtained from MLS, public records, and other data sources identified herein.',
    'My opinion of value is effective as of the date stated in this report.',
    ...(hasArvOption
      ? [
        'I reviewed the client-provided Scope of Work/renovation budget and relied on it to form the basis of the After-Repair Value opinion.',
      ]
      : []),
  ];

  return (
    <Tkv2PDFPage title="Certification" address={subjectAddress}>
      <View style={styles.certificationStatementPageContainer}>
        <View style={styles.certificationStatementTitleContainer}>
          <Text style={fontStyles.h4}>Appraiser Certifications</Text>
        </View>
        <View style={styles.certificationStatementTitleContainer}>
          <Text style={fontStyles.body}>
            I certify that, to the best of my knowledge and belief:
          </Text>
        </View>
        {items.map((item, index) => (
          <View key={index} style={{ flexDirection: 'row', marginBottom: 6 }}>
            <Text style={[fontStyles.body, { width: 20 }]}>{index + 1}.</Text>
            <Text style={[fontStyles.body, { flex: 1 }]}>{item}</Text>
          </View>
        ))}
        <View style={{ marginTop: 8 }}>
          <Text style={fontStyles.body}>
            <Text style={fontStyles.bodyBold}>Digital Signature:</Text> If this report is
            transmitted electronically, the appraiser&apos;s digital signature carries the same
            legal effect as a handwritten signature.
          </Text>
        </View>
      </View>
    </Tkv2PDFPage>
  );
};
